import PrintPriceCalculator from '@shared/utils/print-price/PrintPriceCalculator';
import { StationeryDiscountInfo, StationeryProduct } from '@shared/utils/print-price/types';
import { useMemo } from 'react';

interface UseSamplePackPricesArgs {
  product: StationeryProduct;
  discount?: StationeryDiscountInfo | null;
  deliveryMethod?: string;
}

export const useSamplePackPrices = ({ product, discount, deliveryMethod }: UseSamplePackPricesArgs) => {
  return useMemo(() => {
    const calculator = new PrintPriceCalculator([product]);

    const priceInfo = calculator.getProductPrice(product.id, 1, [], deliveryMethod, discount || undefined);

    const basePrice = priceInfo.lineItems.find(item => item.type === 'base_cost')?.totalPriceInMinorUnits ?? 0;
    const discountAmount = priceInfo.discounts?.savingsInMinorUnits ?? 0;
    const shipping = priceInfo.lineItems.find(item => item.type === 'delivery');

    return {
      basePrice: { totalInMinorUnits: basePrice - discountAmount },
      shipping: shipping,
    };
  }, [deliveryMethod, discount, product]);
};
